import dayjs from 'dayjs';
import { formatPrice } from '../../appointments/v2/utils/appointmentUtils';

/** Formatação dos números das estatísticas (pt-BR). */

export const formatMoney = (value) => formatPrice(Number(value) || 0);

/** Valor em reais sem centavos, para eixos e rótulos curtos: "R$ 12,5 mil". */
export function formatMoneyShort(value) {
  const number = Number(value) || 0;
  if (Math.abs(number) >= 1000) {
    return `R$ ${(number / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`;
  }
  return `R$ ${number.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}`;
}

export const formatNumber = (value, digits = 0) =>
  (Number(value) || 0).toLocaleString('pt-BR', { maximumFractionDigits: digits });

export const formatPercent = (value) => `${formatNumber(value, 1)}%`;

/** Formata um valor conforme o tipo do indicador. */
export function formatValue(value, type) {
  if (value === null || value === undefined) return '—';
  switch (type) {
    case 'money': return formatMoney(value);
    case 'percent': return formatPercent(value);
    case 'decimal': return formatNumber(value, 1);
    case 'days': return `${formatNumber(value, 1)} ${Number(value) === 1 ? 'dia' : 'dias'}`;
    default: return formatNumber(value);
  }
}

/** Rótulo do balde de um gráfico: dia "07/10", semana "07/10", mês "out/26". */
export function formatBucket(bucket, granularity) {
  if (granularity === 'month') {
    const date = dayjs(`${bucket}-01`);
    const months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
    return `${months[date.month()]}/${date.format('YY')}`;
  }
  return dayjs(bucket).format('DD/MM');
}

export const formatDate = (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '');

/** "por dia", "por semana" ou "por mês", conforme o agrupamento do gráfico. */
export const granularityHint = (granularity) =>
  ({ day: 'por dia', week: 'por semana', month: 'por mês' }[granularity] || '');
